import {HealthRating} from "../domain/HealthRating";

const ratingToColorMapLight = new Map([
    [HealthRating.UNKNOWN, "#edf3ff"],
    [HealthRating.HEALTHY, "#e4fae0"],
    [HealthRating.WARNING, "#fff5dc"],
    [HealthRating.SEVERE, "#ffe8e8"]
]);

const ratingToColorMapHeavy = new Map([
    [HealthRating.UNKNOWN, "#639cfc"],
    [HealthRating.HEALTHY, "#42d55b"],
    [HealthRating.WARNING, "#f5c528"],
    [HealthRating.SEVERE, "#d92222"]
]);


export function healthRatingLightColor(rating:HealthRating) {
    return ratingToColorMapLight.get(rating);
}

export function healthRatingHeavyColor(rating:HealthRating) {
    return ratingToColorMapHeavy.get(rating);
}